import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NkModalContent, NkModalService } from '../../services/nk-modal.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'nk-root-modal',
  templateUrl: './nk-modal.component.html',
  styleUrls: ['./nk-modal.component.scss'],
  standalone: false,
})
export class NkModalComponent implements OnInit {
  public open = false;
  public modalRef: BsModalRef;

  @ViewChild('template') public template: TemplateRef<ElementRef>;
  public content: NkModalContent;
  constructor(
    private _appModalService: NkModalService,
    private _modalService: BsModalService,
  ) {}

  public ngOnInit(): void {
    this._appModalService.modal$.subscribe((config) => {
      this.content = config;
      // open modal
      this.open = true;
      this.modalRef = this._modalService.show(this.template);
    });
  }
}
